import GlobalWindow from "../Models/Window";

const openWebPage = (url: string, refreshOnReturn: boolean = false, urlScheme?: string) => {
    const globalWindow: GlobalWindow = window as GlobalWindow;
    if (globalWindow.webkit) {
        globalWindow.webkit.messageHandlers.url.postMessage(
            {
                url,
                urlScheme,
                refresh: refreshOnReturn,
            }
        );
    } else
        window.open(url);
}

export default openWebPage;